import React, { Component } from "react";
import { connect } from "react-redux";
import {
  UpdatePayment,
  OtherPayment,
  CheckoutCurrentCart,
} from "../../../../redux/actions/Cart.Action";

import fonepay from "../../../../assets/img/payment/Fonepay.png";

import { QRCode } from "react-qrcode-logo";
import ApiConnect from "../../../../Utils/ApiConnect";
import scan from "../../../../assets/img/payment/scan.svg";
import qrsuccess from "../../../../assets/img/payment/qrsuccess.svg";
import loading from "../../../../assets/img/loading.svg";

class Fonepay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      qrmsg: false,
      qrimage: scan,
      message: "",
      wimage: false,
      showCheckout: false,
    };
  }
  componentDidMount() {
    this.handle_Fonepay(this.props.order_id);
    this.props.UpdatePayment("Fonepay", this.props.CurrentCart.total, "");
  }
  handle_Fonepay(order) {
    ApiConnect.get("POS/Checkout/FonepayQR?orderid=" + order)
      .then((response) => {
        if (response.data.status === 201) {
          // console.log(response.data)
          if (response.data.socket) {
            this.RealTimeSocket(response.data.socket);
          }
          this.setState({
            qrmsg: response.data.qrMessage,
          });
        } else if (response.data.status === 202) {
          this.setState({ qrmsg: "", qrimage: qrsuccess, message: "" });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  RealTimeSocket(url) {
    const client = new WebSocket(url);
    client.onopen = (e) => {
      //   console.log(e);
    };
    client.onerror = (e) => {
      console.log(e);
    };
    client.onmessage = (e) => {
      //   console.log("socken message");
      const data = JSON.parse(e.data);
      let Status = JSON.parse(data.transactionStatus);
      if (Status.paymentSuccess) {
        this.setState({
          qrimage: qrsuccess,
          qrmsg: "",
          message: "Received " + Status.totalCalculatedAmount,
          showCheckout: true,
        });
        this.props.OtherPayment(
          "Fonepay",
          Status.totalCalculatedAmount,
          Status.traceId
        );
        this.Payment_Verified(
          "Fonepay",
          Status.totalCalculatedAmount,
          Status.traceId
        );
        if (this.props.fallBack) {
          this.props.fallBack();
        }
        if (this.props.autoCheckout) {
          setTimeout(() => {
            this.props.CheckoutCurrentCart("", "");
          }, 10000);
        }
      }
      if (Status.qrVerified) {
        this.setState({ qrimage: loading, qrmsg: "" });
      }
    };
  }
  Payment_Verified(type, amount, tid) {
    ApiConnect.put(
      `POS/Checkout/PaymentDone?orderid=${this.props.order_id}&type=${type}&amount=${amount}&tid=${tid}`
    )
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  render() {
    return (
      <>
        <div className="container text-center">
          <h6>{this.state.message ? this.state.message : ""} </h6>
          <figure className="figure img-thumbnail">
            {this.state.qrmsg ? (
              <QRCode
                value={this.state.qrmsg}
                size="250"
                qrStyle="dots"
                logoHeight={50}
                eyeRadius={50}
              />
            ) : (
              <img src={this.state.qrimage} width="250" alt="default" />
            )}
            <figcaption className="figure-caption text-center">
              <img src={fonepay} width="50" alt="QR PAY" />
            </figcaption>
          </figure>
        </div>
        {this.props.autoCheckout && this.state.showCheckout ? (
          <button
            className="btn btn-primary w-100"
            onClick={() => this.props.CheckoutCurrentCart("", "")}
          >
            Checkout
          </button>
        ) : (
          ""
        )}
      </>
    );
  }
}

export default connect((state) => ({ CurrentCart: state.Cart.CurrentCart }), {
  UpdatePayment,
  OtherPayment,
  CheckoutCurrentCart,
})(Fonepay);
